import { createAsyncThunk } from "@reduxjs/toolkit";

import { getSettings } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";
import { addCSPNonceToHtml } from "@/helpers/csp/add-csp-nonce-to-html";

export const fetchSettings = createAsyncThunk(
  "settings/fetchSettings",
  async (params: Partial<{ config: any }>, { getState, rejectWithValue }) => {
    try {
      const { config } = params;
      const { adapter } = getState() as AppState;
      const { baseUrl, nonce } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      let response = await getSettings(token, baseUrl, config);

      response = {
        ...response,
        customHeadCode: addCSPNonceToHtml(response.customHeadCode, nonce),
        customTrackingCode: addCSPNonceToHtml(
          response.customTrackingCode,
          nonce
        )
      };

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
